import React from 'react';
import { getWSUrl } from '../functions';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
import { BRAND_CONFIGS, getBrandCapitalized, getBrand, getBrandPasswordRecoveryPath } from '../../utils/brandUtils';
class LoginPopup extends AbstractWelcomePage {
    email;
    password;
    divError;
    brandCapitalized = getBrandCapitalized();
    brand = getBrand();
    passwordRecoveryPath = getBrandPasswordRecoveryPath();
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            loginResult: ''
        };
        this.email = React.createRef();
        this.password = React.createRef();
        this.divError = React.createRef();
    }
    componentDidMount() {
        this.email.current?.focus();
    }
    ShowSecond() {
        var divErrore = this.divError;
        if (divErrore.current !== null)
            divErrore.current.className = "showMessaggiPopup";
        setTimeout(function () { if (divErrore.current !== null)
            divErrore.current.className = "hideMessaggiPopup"; }, 2000);
    }
    _onLogin() {
        this.setState({ loginResult: "" });
        this.ShowSecond();
        // Call to internal service due to CORS rules
        fetch("https://" + getWSUrl() + "/loginMeet", {
            method: "POST",
            headers: {
                'Content-Type': 'text/plain'
            },
            body: JSON.stringify({
                username: this.email.current?.value,
                password: this.password.current?.value,
                appName: "Meeting"
            })
        })
            .then(res => res.json())
            .then((result) => {
            var etichetta = "UC.LoginPopup." + result.result;
            this.setState({ loginResult: this.props.t(etichetta) });
            this.props.cambiaStatoLogin(result); //Porto in WelcomePage il cambiamento di stato della login
            if (result.result == 1) {
                location.href = 'https://' + location.hostname;
                this.props.closePopup;
            }
        }, (error) => {
            this.setState({ loginResult: this.props.t('UC.LoginPopup.erroreGenerico') });
        });
        LoginPopup;
    }
    handlePasswordKeyPress = (event) => {
        if (event.key === 'Enter') {
            this._onLogin();
        }
    };
    render() {
        const buttonClass = `button button--${this.brand}`;
        const serviceName = BRAND_CONFIGS[this.brand].name;
        return (React.createElement("div", { className: 'modal' },
            React.createElement("div", { className: 'modal-content' },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "testoPopup" },
                    " ",
                    this.props.t('UC.LoginPopup.intestazione'),
                    " ",
                    serviceName,
                    " "),
                React.createElement("h4", { className: "testoPopup" },
                    " ",
                    this.props.t('UC.LoginPopup.inserisciCredenziali', { brand: this.brandCapitalized }),
                    " "),
                React.createElement("div", null,
                    React.createElement("input", { type: "text", name: "email", placeholder: "email", ref: this.email, onKeyPress: this.handlePasswordKeyPress })),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement("input", { type: "password", name: "password", placeholder: "password", ref: this.password, onKeyPress: this.handlePasswordKeyPress })),
                React.createElement("div", { id: "divErrore", className: "hideMessaggiPopup", ref: this.divError },
                    React.createElement("p", { className: "messaggiPopup" },
                        " ",
                        this.state.loginResult,
                        " ")),
                React.createElement("br", null),
                React.createElement("button", { className: buttonClass, name: "buttonLogin", onClick: () => { this._onLogin(); } },
                    " ",
                    this.props.t('UC.LoginPopup.accedi'),
                    " "),
                React.createElement("br", null),
                React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                    React.createElement("small", { className: "news" },
                        " ",
                        this.props.t('UC.LoginPopup.passwordDimenticata1')),
                    " ",
                    React.createElement("a", { className: "showNewFeatures", target: "_black", href: this.passwordRecoveryPath }, this.props.t('UC.LoginPopup.passwordDimenticata2'))))));
    }
}
//export default UC.LoginPopup;
export default translate(connect(_mapStateToProps)(LoginPopup));
